export enum WorkflowTemplateOrganisationAccessLevel {
  Owner = "Owner",
  Author = "Author",
  Contributor = "Contributor",
  Viewer = "Viewer",
}
